export const CategoryPetition =
[
  {
    'children': [
      {
        'id': '',
        'code': '0',
        'name': '非密',
        'parentId': 'mjbs'
      },
      {
        'id': '',
        'code': '1',
        'name': '秘密',
        'parentId': 'mjbs'
      },
      {
        'id': '',
        'code': '2',
        'name': '机密',
        'parentId': 'mjbs'
      },
    ],
    'code': 'mjbs',
    'id': '',
    'name': '密级标识',
    'parentId': '0'
  },
  {
    'children': [
      {
        'id': '',
        'code': '1',
        'name': '来信',
        'parentId': 'jbfs'
      },
      {
        'id': '',
        'code': '2',
        'name': '来访',
        'parentId': 'jbfs'
      },
      {
        'id': '',
        'code': '3',
        'name': '电话举报',
        'parentId': 'jbfs'
      },
      {
        'id': '',
        'code': '4',
        'name': '网络举报',
        'parentId': 'jbfs'
      },
      {
        'id': '',
        'code': '5',
        'name': '其他方式',
        'parentId': 'jbfs'
      },
    ],
    'code': 'jbfs',
    'id': '',
    'name': '信访方式(信访举报方式)',
    'parentId': '0'
  },
  {
    'children': [
      {
        'id':'',
        'code':'1',
        'name':'检举控告',
        'parentId':'xflb'
      },
      {
        'id':'',
        'code':'2',
        'name':'申诉',
        'parentId':'xflb'
      },
      {
        'id':'',
        'code':'3',
        'name':'批评建议',
        'parentId':'xflb'
      },
      {
        'id':'',
        'code':'4',
        'name':'业务范围外',
        'parentId':'xflb'
      },
    ],
    'code': 'xflb',
    'id': '',
    'name': '信访类别(信访举报类型)',
    'parentId': '0'
  },
  {
    'children': [
      {
        'id':'',
        'code':'0202',
        'name':'上级交办',
        'parentId':'xfly'
      },
      {
        'id':'',
        'code':'0201',
        'name':'上级转送',
        'parentId':'xfly'
      },
      {
        'id':'',
        'code':'0101',
        'name':'本级受理',
        'parentId':'xfly'
      },
      {
        'id':'',
        'code':'0401',
        'name':'下级报送',
        'parentId':'xfly'
      },
      {
        'id':'',
        'code':'0301',
        'name':'其他单位移交',
        'parentId':'xfly'
      },
    ],
    'code': 'xfly',
    'id': '',
    'name': '信访来源(信访举报来源)',
    'parentId': '0'
  },
  {
    'children': [
      {
        'id':'',
        'code':'1',
        'name':'是',
        'parentId':'isUnit'
      },
      {
        'id':'',
        'code':'2',
        'name':'否',
        'parentId':'isUnit'
      },
    ],
    'code': 'isUnit',
    'id': '',
    'name': '是否单位或事件(对象类型)',
    'parentId': '0'
  },
  {
    'children': [
      // {
      //   'id':'',
      //   'code':'0200',
      //   'name':'正省部级',
      //   'parentId':'zj'
      // },
      // {
      //   'id':'',
      //   'code':'0202',
      //   'name':'副省部级',
      //   'parentId':'zj'
      // },
      // {
      //   'id':'',
      //   'code':'0300',
      //   'name':'正厅局级',
      //   'parentId':'zj'
      // },
      // {
      //   'id':'',
      //   'code':'0302',
      //   'name':'副厅局级',
      //   'parentId':'zj'
      // },
      {
        'id':'',
        'code':'0400',
        'name':'正县处级',
        'parentId':'zj'
      },
      {
        'id':'',
        'code':'0402',
        'name':'副县处级',
        'parentId':'zj'
      },
      {
        'id':'',
        'code':'0500',
        'name':'正乡科级',
        'parentId':'zj'
      },
      {
        'id':'',
        'code':'0502',
        'name':'副乡科级',
        'parentId':'zj'
      },
      {
        'id':'',
        'code':'0600',
        'name':'一般干部',
        'parentId':'zj'
      },
      {
        'id':'',
        'code':'0901',
        'name':'其他人员（军队）',
        'parentId':'zj'
      },
      {
        'id':'',
        'code':'0903',
        'name':'其他人员（一般企业）',
        'parentId':'zj'
      },
      {
        'id':'',
        'code':'0904',
        'name':'其他人员（农村）',
        'parentId':'zj'
      },
      {
        'id':'',
        'code':'0905',
        'name':'其他人员（其他）',
        'parentId':'zj'
      },
      {
        'id':'',
        'code':'0906',
        'name':'其他人员（金融机构）',
        'parentId':'zj'
      },
      {
        'id':'',
        'code':'0907',
        'name':'其他人员（事业）',
        'parentId':'zj'
      },
      {
        'id':'',
        'code':'0908',
        'name':'其他人员（社区）',
        'parentId':'zj'
      },
    ],
    'code': 'zj',
    'id': '',
    'name': '职级',
    'parentId': '0'
  },
  {
    'children': [
      {
        'id':'',
        'code':'001A',
        'name':'副处长',
        'parentId':'zw'
      },
      {
        'id':'',
        'code':'010A',
        'name':'书记',
        'parentId':'zw'
      },
      {
        'id':'',
        'code':'009B',
        'name':'副科长',
        'parentId':'zw'
      },
      {
        'id':'',
        'code':'009A',
        'name':'科长',
        'parentId':'zw'
      },
      {
        'id':'',
        'code':'008B',
        'name':'副处长',
        'parentId':'zw'
      },
      {
        'id':'',
        'code':'008A',
        'name':'处长',
        'parentId':'zw'
      },
      {
        'id':'',
        'code':'007B',
        'name':'副局长',
        'parentId':'zw'
      },
      {
        'id':'',
        'code':'007A',
        'name':'局长',
        'parentId':'zw'
      },
      {
        'id':'',
        'code':'006B',
        'name':'副厅长',
        'parentId':'zw'
      },
      {
        'id':'',
        'code':'006A',
        'name':'厅长',
        'parentId':'zw'
      },
      {
        'id':'',
        'code':'005B',
        'name':'副主任',
        'parentId':'zw'
      },
      {
        'id':'',
        'code':'005A',
        'name':'主任',
        'parentId':'zw'
      },
      {
        'id':'',
        'code':'004B',
        'name':'派驻纪检组副组长',
        'parentId':'zw'
      },
      {
        'id':'',
        'code':'004A',
        'name':'派驻纪检组组长',
        'parentId':'zw'
      },
      {
        'id':'',
        'code':'003B',
        'name':'副秘书长',
        'parentId':'zw'
      },
      {
        'id':'',
        'code':'003A',
        'name':'秘书长',
        'parentId':'zw'
      },
      {
        'id':'',
        'code':'002B',
        'name':'副部长',
        'parentId':'zw'
      },
      {
        'id':'',
        'code':'002A',
        'name':'部长',
        'parentId':'zw'
      },
      {
        'id':'',
        'code':'001C',
        'name':'常委',
        'parentId':'zw'
      },
      {
        'id':'',
        'code':'001B',
        'name':'副书记',
        'parentId':'zw'
      },
    ],
    'code': 'zw',
    'id': '',
    'name': '职务',
    'parentId': '0'
  },
  {
    'children': [
      {
        'id':'',
        'code':'07',
        'name':'公安部测试身份一',
        'parentId':'sf'
      },
      {
        'id':'',
        'code':'08',
        'name':'公安部测试身份二',
        'parentId':'sf'
      },
      {
        'id':'',
        'code':'09',
        'name':'外交测试1',
        'parentId':'sf'
      },
      {
        'id':'',
        'code':'10',
        'name':'外交测试2',
        'parentId':'sf'
      },
    ],
    'code': 'sf',
    'id': '',
    'name': '身份',
    'parentId': '0'
  },
  {
    'children': [
      {
        'id':'',
        'code':'01',
        'name':'党的机关',
        'parentId':'jgdw'
      },
      {
        'id':'',
        'code':'13',
        'name':'参公管理单位',
        'parentId':'jgdw'
      },
      {
        'id':'',
        'code':'11',
        'name':'民主党派机关和工商联机关',
        'parentId':'jgdw'
      },
      {
        'id':'',
        'code':'10',
        'name':'人民检察院',
        'parentId':'jgdw'
      },
      {
        'id':'',
        'code':'09',
        'name':'人民法院',
        'parentId':'jgdw'
      },
      {
        'id':'',
        'code':'08',
        'name':'监察委员会',
        'parentId':'jgdw'
      },
      {
        'id':'',
        'code':'07',
        'name':'政协机关',
        'parentId':'jgdw'
      },
      {
        'id':'',
        'code':'06',
        'name':'人民政府',
        'parentId':'jgdw'
      },
      {
        'id':'',
        'code':'05',
        'name':'人大机关',
        'parentId':'jgdw'
      },
      {
        'id':'',
        'code':'99',
        'name':'其他',
        'parentId':'jgdw'
      },
    ],
    'code': 'jgdw',
    'id': '',
    'name': '机关单位类别',
    'parentId': '0'
  },
  {
    'children': [
      {
        'id':'',
        'code':'1',
        'name':'男',
        'parentId':'xb'
      },
      {
        'id':'',
        'code':'2',
        'name':'女',
        'parentId':'xb'
      },
    ],
    'code': 'xb',
    'id': '',
    'name': '性别',
    'parentId': '0'
  },
  {
    'children': [
      {
        'id':'',
        'code':'1',
        'name':'党员',
        'parentId':'jddx'
      },
      {
        'id':'',
        'code':'2',
        'name':'党组织',
        'parentId':'jddx'
      },
      {
        'id':'',
        'code':'7',
        'name':'监察对象',
        'parentId':'jddx'
      },
      {
        'id':'',
        'code':'6',
        'name':'党员并监察对象',
        'parentId':'jddx'
      },
      {
        'id':'',
        'code':'8',
        'name':'其他人员（其他）',
        'parentId':'jddx'
      },
    ],
    'code': 'jddx',
    'id': '',
    'name': '监督对象',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': '01',
        'id': '258',
        'name': '汉族',
        'parentId': 'mz'
      },
      {
        'code': '02',
        'id': '259',
        'name': '蒙古族',
        'parentId': 'mz'
      },
      {
        'code': '03',
        'id': '260',
        'name': '回族',
        'parentId': 'mz'
      },
      {
        'code': '04',
        'id': '261',
        'name': '藏族',
        'parentId': 'mz'
      },
      {
        'code': '05',
        'id': '262',
        'name': '维吾尔族',
        'parentId': 'mz'
      },
      {
        'code': '06',
        'id': '263',
        'name': '苗族',
        'parentId': 'mz'
      },
      {
        'code': '07',
        'id': '264',
        'name': '彝族',
        'parentId': 'mz'
      },
      {
        'code': '08',
        'id': '265',
        'name': '壮族',
        'parentId': 'mz'
      },
      {
        'code': '09',
        'id': '266',
        'name': '布依族',
        'parentId': 'mz'
      },
      {
        'code': '10',
        'id': '267',
        'name': '朝鲜族',
        'parentId': 'mz'
      },
      {
        'code': '11',
        'id': '268',
        'name': '满族',
        'parentId': 'mz'
      },
      {
        'code': '12',
        'id': '269',
        'name': '侗族',
        'parentId': 'mz'
      },
      {
        'code': '13',
        'id': '270',
        'name': '瑶族',
        'parentId': 'mz'
      },
      {
        'code': '14',
        'id': '271',
        'name': '白族',
        'parentId': 'mz'
      },
      {
        'code': '15',
        'id': '272',
        'name': '土家族',
        'parentId': 'mz'
      },
      {
        'code': '16',
        'id': '273',
        'name': '哈尼族',
        'parentId': 'mz'
      },
      {
        'code': '17',
        'id': '274',
        'name': '哈萨克族',
        'parentId': 'mz'
      },
      {
        'code': '18',
        'id': '275',
        'name': '傣族',
        'parentId': 'mz'
      },
      {
        'code': '19',
        'id': '276',
        'name': '黎族',
        'parentId': 'mz'
      },
      {
        'code': '20',
        'id': '277',
        'name': '傈僳族',
        'parentId': 'mz'
      },
      {
        'code': '21',
        'id': '278',
        'name': '佤族',
        'parentId': 'mz'
      },
      {
        'code': '22',
        'id': '279',
        'name': '畲族',
        'parentId': 'mz'
      },
      {
        'code': '23',
        'id': '280',
        'name': '高山族',
        'parentId': 'mz'
      },
      {
        'code': '24',
        'id': '281',
        'name': '拉祜族',
        'parentId': 'mz'
      },
      {
        'code': '25',
        'id': '282',
        'name': '水族',
        'parentId': 'mz'
      },
      {
        'code': '26',
        'id': '283',
        'name': '东乡族',
        'parentId': 'mz'
      },
      {
        'code': '27',
        'id': '284',
        'name': '纳西族',
        'parentId': 'mz'
      },
      {
        'code': '28',
        'id': '285',
        'name': '景颇族',
        'parentId': 'mz'
      },
      {
        'code': '29',
        'id': '286',
        'name': '柯尔克孜族',
        'parentId': 'mz'
      },
      {
        'code': '30',
        'id': '287',
        'name': '土族',
        'parentId': 'mz'
      },
      {
        'code': '31',
        'id': '288',
        'name': '达斡尔族',
        'parentId': 'mz'
      },
      {
        'code': '32',
        'id': '289',
        'name': '仫佬族',
        'parentId': 'mz'
      },
      {
        'code': '33',
        'id': '290',
        'name': '羌族',
        'parentId': 'mz'
      },
      {
        'code': '34',
        'id': '291',
        'name': '布朗族',
        'parentId': 'mz'
      },
      {
        'code': '35',
        'id': '292',
        'name': '撒拉族',
        'parentId': 'mz'
      },
      {
        'code': '36',
        'id': '293',
        'name': '毛南族',
        'parentId': 'mz'
      },
      {
        'code': '37',
        'id': '294',
        'name': '仡佬族',
        'parentId': 'mz'
      },
      {
        'code': '38',
        'id': '295',
        'name': '锡伯族',
        'parentId': 'mz'
      },
      {
        'code': '39',
        'id': '296',
        'name': '阿昌族',
        'parentId': 'mz'
      },
      {
        'code': '40',
        'id': '297',
        'name': '普米族',
        'parentId': 'mz'
      },
      {
        'code': '41',
        'id': '298',
        'name': '塔吉克族',
        'parentId': 'mz'
      },
      {
        'code': '42',
        'id': '299',
        'name': '怒族',
        'parentId': 'mz'
      },
      {
        'code': '43',
        'id': '300',
        'name': '乌孜别克族',
        'parentId': 'mz'
      },
      {
        'code': '44',
        'id': '301',
        'name': '俄罗斯族',
        'parentId': 'mz'
      },
      {
        'code': '45',
        'id': '302',
        'name': '鄂温克族',
        'parentId': 'mz'
      },
      {
        'code': '46',
        'id': '303',
        'name': '德昂族',
        'parentId': 'mz'
      },
      {
        'code': '47',
        'id': '304',
        'name': '保安族',
        'parentId': 'mz'
      },
      {
        'code': '48',
        'id': '305',
        'name': '裕固族',
        'parentId': 'mz'
      },
      {
        'code': '49',
        'id': '306',
        'name': '京族',
        'parentId': 'mz'
      },
      {
        'code': '50',
        'id': '307',
        'name': '塔塔尔族',
        'parentId': 'mz'
      },
      {
        'code': '51',
        'id': '308',
        'name': '独龙族',
        'parentId': 'mz'
      },
      {
        'code': '52',
        'id': '309',
        'name': '鄂伦春族',
        'parentId': 'mz'
      },
      {
        'code': '53',
        'id': '310',
        'name': '赫哲族',
        'parentId': 'mz'
      },
      {
        'code': '54',
        'id': '311',
        'name': '门巴族',
        'parentId': 'mz'
      },
      {
        'code': '55',
        'id': '312',
        'name': '珞巴族',
        'parentId': 'mz'
      },
      {
        'code': '56',
        'id': '',
        'name': '基诺族',
        'parentId': 'mz'
      }
    ],
    'code': 'mz',
    'id': '',
    'name': '民族',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': '1',
        'id': '',
        'name': '党员',
        'parentId': 'zzmm'
      },
      {
        'code': '2',
        'id': '',
        'name': '法人',
        'parentId': 'zzmm'
      },
      {
        'code': '3',
        'id': '',
        'name': '党组织',
        'parentId': 'zzmm'
      },
      {
        'code': '4',
        'id': '',
        'name': '其他',
        'parentId': 'zzmm'
      },
      {
        'code': '5',
        'id': '',
        'name': '民主党派',
        'parentId': 'zzmm'
      },
      {
        'code': '6',
        'id': '',
        'name': '团员',
        'parentId': 'zzmm'
      },
    ],
    'code': 'zzmm',
    'id': '',
    'name': '政治面貌',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': '1',
        'id': '',
        'name': '国家机关工作人员',
        'parentId': 'zy'
      },
      {
        'code': '2',
        'id': '',
        'name': '群众组织、人民团体工作人员',
        'parentId': 'zy'
      },
      {
        'code': '3',
        'id': '',
        'name': '事业单位工作人员',
        'parentId': 'zy'
      },
      {
        'code': '4',
        'id': '',
        'name': '国有企业工作人员',
        'parentId': 'zy'
      },
      {
        'code': '5',
        'id': '',
        'name': '其他性质企业工作人员',
        'parentId': 'zy'
      },
      {
        'code': '6',
        'id': '',
        'name': '农、林、牧、渔劳动者',
        'parentId': 'zy'
      },
      {
        'code': '7',
        'id': '',
        'name': '离、退休人员',
        'parentId': 'zy'
      },
      {
        'code': '8',
        'id': '',
        'name': '无业人员',
        'parentId': 'zy'
      },
      {
        'code': '9',
        'id': '',
        'name': '不便分类的其他人员',
        'parentId': 'zy'
      },
    ],
    'code': 'zy',
    'id': '',
    'name': '职业',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': '0121',
        'id': '',
        'name': '违反政治纪律行为',
        'parentId': 'wtxzlb',
        disabled: true,
        'children': [
          {
            'code': '012109',
            'id': '',
            'name': '在重大原则问题上不同党中央保持一致',
            'parentId': 'wtxzlb'
          },
          {
            'code': '012118',
            'id': '',
            'name': '违反党的优良传统和工作惯例',
            'parentId': 'wtxzlb'
          },
          {
            'code': '012108',
            'id': '',
            'name': '无原则一团和气和违反政治规矩',
            'parentId': 'wtxzlb'
          },
          {
            'code': '012116',
            'id': '',
            'name': '不履行“两个责任”或履行不力',
            'parentId': 'wtxzlb'
          },
          {
            'code': '012107',
            'id': '',
            'name': '叛逃及涉外活动中损害党和国家利益',
            'parentId': 'wtxzlb'
          },
          {
            'code': '012106',
            'id': '',
            'name': '信仰宗教或组织参加迷信活动',
            'parentId': 'wtxzlb'
          },
          {
            'code': '012115',
            'id': '',
            'name': '违反党和国家民族、宗教政策',
            'parentId': 'wtxzlb'
          },
          {
            'code': '012102',
            'id': '',
            'name': '参加反对党和政府的活动或组织',
            'parentId': 'wtxzlb'
          },
          {
            'code': '012105',
            'id': '',
            'name': '对抗组织审查',
            'parentId': 'wtxzlb'
          },
          {
            'code': '012114',
            'id': '',
            'name': '干扰巡视巡察或不落实整改要求',
            'parentId': 'wtxzlb'
          },
          {
            'code': '012113',
            'id': '',
            'name': '不按规定请示报告重大事项',
            'parentId': 'wtxzlb'
          },
          {
            'code': '012112',
            'id': '',
            'name': '制造散布传播政治谣言，搞诬告陷害',
            'parentId': 'wtxzlb'
          },
          {
            'code': '012111',
            'id': '',
            'name': '对党不忠诚不老实、搞两面派、做两面人',
            'parentId': 'wtxzlb'
          },
          {
            'code': '012104',
            'id': '',
            'name': '落实党中央决策部署打折扣、搞变通',
            'parentId': 'wtxzlb'
          },
          {
            'code': '012117',
            'id': '',
            'name': '自行其是搞山头主义拒不执行中央大政方针',
            'parentId': 'wtxzlb'
          },
          {
            'code': '012103',
            'id': '',
            'name': '在党内搞团团伙伙',
            'parentId': 'wtxzlb'
          },
          {
            'code': '012110',
            'id': '',
            'name': '诋毁、诬蔑党和国家领导人、英模，歪曲历史',
            'parentId': 'wtxzlb'
          },
          {
            'code': '012101',
            'id': '',
            'name': '公开发表危害党的言论',
            'parentId': 'wtxzlb'
          },
        ]
      },
      {
        'code': '0122',
        'id': '',
        'name': '违反组织纪律行为',
        'parentId': 'wtxzlb',
        disabled: true,
        'children': [
          {
            'code': '012201',
            'id': '',
            'name': '违反民主集中制原则',
            'parentId': 'wtxzlb'
          },
          {
            'code': '012202',
            'id': '',
            'name': '不按要求请示报告个人有关事项',
            'parentId': 'wtxzlb'
          },
          {
            'code': '012203',
            'id': '',
            'name': '违规组织参加老乡会校友会战友会',
            'parentId': 'wtxzlb'
          },
          {
            'code': '012204',
            'id': '',
            'name': '侵犯党员权利',
            'parentId': 'wtxzlb'
          },
          {
            'code': '012205',
            'id': '',
            'name': '在投票和选举中搞非组织活动',
            'parentId': 'wtxzlb'
          },
          {
            'code': '012206',
            'id': '',
            'name': '违反干部选拔任用规定',
            'parentId': 'wtxzlb'
          },
          {
            'code': '012207',
            'id': '',
            'name': '在人事劳动工作中违规谋利',
            'parentId': 'wtxzlb'
          },
          {
            'code': '012208',
            'id': '',
            'name': '违规发展党员',
            'parentId': 'wtxzlb'
          },
          {
            'code': '012209',
            'id': '',
            'name': '违规办理出国证件和在境外脱离组织',
            'parentId': 'wtxzlb'
          },
        ]
      },
      {
        'code': '0123',
        'id': '',
        'name': '违反廉洁纪律行为',
        'parentId': 'wtxzlb',
        disabled: true,
        'children': [
          {
            'code': '012301',
            'id': '',
            'name': '权权交易和纵容特定关系人以权谋私',
            'parentId': 'wtxzlb'
          },
          {
            'code': '012302',
            'id': '',
            'name': '违规收送礼品礼金、金融产品及宴请服务等',
            'parentId': 'wtxzlb'
          },
          {
            'code': '012303',
            'id': '',
            'name': '违规操办婚丧喜庆事宜',
            'parentId': 'wtxzlb'
          },
          {
            'code': '012304',
            'id': '',
            'name': '违规从事营利活动',
            'parentId': 'wtxzlb'
          },
          {
            'code': '012305',
            'id': '',
            'name': '违反工作生活待遇规定',
            'parentId': 'wtxzlb'
          },
          {
            'code': '012306',
            'id': '',
            'name': '违规占有使用公私财物',
            'parentId': 'wtxzlb'
          },
          {
            'code': '012307',
            'id': '',
            'name': '违规参与公款宴请消费',
            'parentId': 'wtxzlb'
          },
          {
            'code': '012308',
            'id': '',
            'name': '违规自定薪酬和发放津贴补贴奖金',
            'parentId': 'wtxzlb'
          },
          {
            'code': '012309',
            'id': '',
            'name': '公款旅游',
            'parentId': 'wtxzlb'
          },
          {
            'code': '012310',
            'id': '',
            'name': '违反公务接待管理规定',
            'parentId': 'wtxzlb'
          },
          {
            'code': '012311',
            'id': '',
            'name': '违反公务用车管理规定',
            'parentId': 'wtxzlb'
          },
          {
            'code': '012312',
            'id': '',
            'name': '违反会议活动管理规定',
            'parentId': 'wtxzlb'
          },
          {
            'code': '012313',
            'id': '',
            'name': '违反办公用房管理规定',
            'parentId': 'wtxzlb'
          },
          {
            'code': '012314',
            'id': '',
            'name': '权色钱色交易',
            'parentId': 'wtxzlb'
          },
          {
            'code': '012315',
            'id': '',
            'name': '其他违反廉洁纪律行为',
            'parentId': 'wtxzlb'
          },
          {
            'code': '012316',
            'id': '',
            'name': '借用管理服务对象财物或通过民间借贷等获取大额回报',
            'parentId': 'wtxzlb'
          },
        ]
      },
      {
        'code': '0124',
        'id': '',
        'name': '违反群众纪律行为',
        'parentId': 'wtxzlb',
        disabled: true,
        'children': [
          {
            'code': '012401',
            'id': '',
            'name': '侵害群众利益',
            'parentId': 'wtxzlb'
          },
          {
            'code': '012402',
            'id': '',
            'name': '漠视群众利益',
            'parentId': 'wtxzlb'
          },
          {
            'code': '012402',
            'id': '',
            'name': '漠视群众利益',
            'parentId': 'wtxzlb'
          },
          {
            'code': '012403',
            'id': '',
            'name': '侵犯群众知情权',
            'parentId': 'wtxzlb'
          },
          {
            'code': '012404',
            'id': '',
            'name': '其他违反群众纪律行为',
            'parentId': 'wtxzlb'
          },
          {
            'code': '012405',
            'id': '',
            'name': '搞形象工程、政绩工程',
            'parentId': 'wtxzlb'
          },
          {
            'code': '012406',
            'id': '',
            'name': '利用宗族黑恶势力等欺压群众或充当“保护伞”',
            'parentId': 'wtxzlb'
          },
        ]
      },
      {
        'code': '0125',
        'id': '',
        'name': '违反工作纪律行为',
        'parentId': 'wtxzlb',
        disabled: true,
        'children': [
          {
            'code': '012502',
            'id': '',
            'name': '违规干预市场经济活动',
            'parentId': 'wtxzlb'
          },
          {
            'code': '012503',
            'id': '',
            'name': '违规干预司法活动执纪执法活动',
            'parentId': 'wtxzlb'
          },
          {
            'code': '012504',
            'id': '',
            'name': '泄露扩散窃取私存党的秘密',
            'parentId': 'wtxzlb'
          },
          {
            'code': '012505',
            'id': '',
            'name': '违反考试录取工作规定',
            'parentId': 'wtxzlb'
          },
          {
            'code': '012506',
            'id': '',
            'name': '其他违反工作纪律行为',
            'parentId': 'wtxzlb'
          },
          {
            'code': '012507',
            'id': '',
            'name': '工作中搞形式主义、官僚主义',
            'parentId': 'wtxzlb'
          },
        ]
      },
      {
        'code': '0126',
        'id': '',
        'name': '违反生活纪律行为',
        'parentId': 'wtxzlb',
        disabled: true,
        'children':[
          {
            'code': '012601',
            'id': '',
            'name': '生活奢靡、贪图享受、追求低级趣味',
            'parentId': 'wtxzlb'
          },
          {
            'code': '012602',
            'id': '',
            'name': '不正当性关系',
            'parentId': 'wtxzlb'
          },
          {
            'code': '012604',
            'id': '',
            'name': '不重视家风建设、对配偶、子女及其配偶失管失教',
            'parentId': 'wtxzlb'
          },
          {
            'code': '012605',
            'id': '',
            'name': '违背公序良俗',
            'parentId': 'wtxzlb'
          },
          {
            'code': '012603',
            'id': '',
            'name': '其他违反生活纪律行为',
            'parentId': 'wtxzlb'
          },
        ]
      },
      {
        'code': '0141',
        'id': '',
        'name': '贪污贿赂类行为',
        'parentId': 'wtxzlb',
        disabled: true,
        'children':[
          {
            'code': '014101',
            'id': '',
            'name': '贪污',
            'parentId': 'wtxzlb'
          },
          {
            'code': '014102',
            'id': '',
            'name': '挪用公款',
            'parentId': 'wtxzlb'
          },
          {
            'code': '014103',
            'id': '',
            'name': '受贿',
            'parentId': 'wtxzlb'
          },
          {
            'code': '014104',
            'id': '',
            'name': '行贿',
            'parentId': 'wtxzlb'
          },
          {
            'code': '014105',
            'id': '',
            'name': '巨额财产来源不明',
            'parentId': 'wtxzlb'
          },
          {
            'code': '014106',
            'id': '',
            'name': '其他贪污贿赂行为',
            'parentId': 'wtxzlb'
          },
          {
            'code': '014107',
            'id': '',
            'name': '非国家工作人员受贿',
            'parentId': 'wtxzlb'
          },
        ]
      },
      {
        'code': '0148',
        'id': '',
        'name': '滥用职权类行为',
        'parentId': 'wtxzlb',
        disabled: true,
        'children':[
          {
            'code': '014801',
            'id': '',
            'name': '滥用职权',
            'parentId': 'wtxzlb'
          },
          {
            'code': '014802',
            'id': '',
            'name': '国有企事业人员滥用职权',
            'parentId': 'wtxzlb'
          },
          {
            'code': '014803',
            'id': '',
            'name': '报复陷害',
            'parentId': 'wtxzlb'
          },
          {
            'code': '014804',
            'id': '',
            'name': '挪用特定款物',
            'parentId': 'wtxzlb'
          },
          {
            'code': '014805',
            'id': '',
            'name': '其他滥用职权类行为',
            'parentId': 'wtxzlb'
          },
        ]
      },
      {
        'code': '0144',
        'id': '',
        'name': '玩忽职守类行为',
        'parentId': 'wtxzlb',
        disabled: true,
        'children':[
          {
            'code': '014401',
            'id': '',
            'name': '玩忽职守',
            'parentId': 'wtxzlb'
          },
          {
            'code': '014402',
            'id': '',
            'name': '国有企事业人员失职',
            'parentId': 'wtxzlb'
          },
          {
            'code': '014403',
            'id': '',
            'name': '环境监管失职',
            'parentId': 'wtxzlb'
          },
          {
            'code': '014404',
            'id': '',
            'name': '其他玩忽职守类行为',
            'parentId': 'wtxzlb'
          },
        ]
      },
      {
        'code': '0145',
        'id': '',
        'name': '徇私舞弊类行为',
        'parentId': 'wtxzlb',
        disabled: true,
        'children':[
          {
            'code': '014501',
            'id': '',
            'name': '徇私舞弊低价折股、出售国有资产',
            'parentId': 'wtxzlb'
          },
          {
            'code': '014502',
            'id': '',
            'name': '非法批准征收、征用、占用土地',
            'parentId': 'wtxzlb'
          },
          {
            'code': '014503',
            'id': '',
            'name': '非法低价出让国有土地使用权',
            'parentId': 'wtxzlb'
          },
          {
            'code': '014504',
            'id': '',
            'name': '非法经营同类营业和为亲友非法牟利',
            'parentId': 'wtxzlb'
          },
          {
            'code': '014505',
            'id': '',
            'name': '招收公务员、学生徇私舞弊',
            'parentId': 'wtxzlb'
          },
          {
            'code': '014506',
            'id': '',
            'name': '其他徇私舞弊类行为',
            'parentId': 'wtxzlb'
          },
        ]
      },
      {
        'code': '0146',
        'id': '',
        'name': '重大责任事故类行为',
        'parentId': 'wtxzlb',
        disabled: true,
        'children': [
          {
            'code': '014601',
            'id': '',
            'name': '重大责任事故',
            'parentId': 'wtxzlb'
          },
          {
            'code': '014602',
            'id': '',
            'name': '不报、谎报安全事故',
            'parentId': 'wtxzlb'
          },
          {
            'code': '014603',
            'id': '',
            'name': '工程重大安全事故',
            'parentId': 'wtxzlb'
          },
          {
            'code': '014604',
            'id': '',
            'name': '其他重大责任事故类行为',
            'parentId': 'wtxzlb'
          },
        ]
      },
      {
        'code': '0147',
        'id': '',
        'name': '行使公权力过程中发生的其他违法犯罪行为',
        'parentId': 'wtxzlb',
        disabled: true,
        'children': [
          {
            'code': '014701',
            'id': '',
            'name': '破坏选举',
            'parentId': 'wtxzlb'
          },
          {
            'code': '014702',
            'id': '',
            'name': '非法转让、倒卖土地使用权',
            'parentId': 'wtxzlb'
          },
          {
            'code': '014703',
            'id': '',
            'name': '职务侵占',
            'parentId': 'wtxzlb'
          },
          {
            'code': '014704',
            'id': '',
            'name': '挪用资金',
            'parentId': 'wtxzlb'
          },
          {
            'code': '014705',
            'id': '',
            'name': '其他行使公权力过程中发生的其他违法犯罪行为',
            'parentId': 'wtxzlb'
          },
        ]
      },
      {
        'code': '0151',
        'id': '',
        'name': '其他违法犯罪行为',
        'parentId': 'wtxzlb',
      },
    ],
    'code': 'wtxzlb',
    'id': '',
    'name': '问题性质类别',
    'parentId': '0'
  },
  {
    'children': [
      {
        'code': '33LU00000000',
        'id': '',
        'name': '驻经信厅纪检组',
        'parentId': 'wtsd',
        'children': [
          {
            'code': '33LUAA000000',
            'id': '',
            'name': '省经信厅',
            'parentId': 'wtsd'
          },
          {
            'code': '33LUAB000000',
            'id': '',
            'name': '驻厅纪检监察室',
            'parentId': 'wtsd'
          },
          {
            'code': '33LUAD000000',
            'id': '',
            'name': '省商务厅',
            'parentId': 'wtsd'
          },
          {
            'code': '33LUAE000000',
            'id': '',
            'name': '省应急管理厅',
            'parentId': 'wtsd'
          },
          {
            'code': '33LUAF000000',
            'id': '',
            'name': '省供销社',
            'parentId': 'wtsd'
          },
          {
            'code': '33LUAG000000',
            'id': '',
            'name': '省商贸会',
            'parentId': 'wtsd'
          },
          {
            'code': '33LUAH000000',
            'id': '',
            'name': '浙江经贸学院',
            'parentId': 'wtsd'
          },
          {
            'code': '33LUAI000000',
            'id': '',
            'name': '浙江农商学院',
            'parentId': 'wtsd'
          },
        ]
      },
    ],
    'code': 'wtsd',
    'id': '',
    'name': '问题属地',
    'parentId': '0'
  }
]



// WEBPACK FOOTER //
// ./src/js/CategoryPetition.js